import Image from "next/image"
import { trackReadMoreClick } from "services/analytics"

import { Links } from "config/links"

import { Box } from "components/shared/box"
import { Button } from "components/shared/landing/button"
import { Link } from "components/shared/link"
import { Text } from "components/shared/text"

export function NftSpaceshipSection() {
  return (
    <>
      <Box className="mt-16 md:flex-row">
        <Box className="h-auto justify-end flex-1 order-1">
          <Text className="text-h4 md:text-h3 text-center md:text-left">Spaceships</Text>
        </Box>

        <Box className=" max-w-[700px] mx-auto w-full animate-wiggle md:order-2">
          <Image
            src="/images/sections/nft-spaceship-section/spaceship.png"
            width={986}
            height={515}
            layout="responsive"
            alt="bot"
          />
        </Box>
      </Box>
      <Box className="mt-6">
        <Box className="max-w-[850px]">
          <Text className="opacity-80">
            A true space explorer needs a Spaceship — you would need one to travel Bots between planets, explore the
            universe with its yummy resources and fight in massive space battles!
          </Text>
          <Text className="mt-4 opacity-80">
            A ship is created by fusing two or more Bots. The Bots are destroyed in the process but create a new type of
            in-game asset: a Spaceship. Just like Bots, Spaceships can also be upgraded by fusing new Bots. The
            improvements include upgraded weapons, engines, protection, and etc.
          </Text>
          <Box row className="flex justify-center md:justify-start">
            <Link href={Links.READ_SHIPS} target="_blank" withRedirect onClick={() => trackReadMoreClick()}>
              <Button size="lg" className="mt-6 w-[220px] md:w-auto">
                Read More
              </Button>
            </Link>
          </Box>
        </Box>
      </Box>
    </>
  )
}
